import type { TableCellProps } from '@mui/material';

import type { SymbolKey } from '@/entities/symbol';
import type { FullScreenLegendSeries } from '../useFullScreenChart';

export type LegendDetailKey = keyof Pick<
  FullScreenLegendSeries,
  'alias' | 'code' | 'currency' | 'name' | 'period' | 'periodType' | 'timeRef' | 'units'
>;

export type LegendDetailColumn = {
  key: LegendDetailKey;
  label: string;
  width?: number;
} & Pick<TableCellProps, 'align'>;

export type LegendTableColumn =
  | LegendDetailColumn
  | ({ key: 'info'; label: string; width: number } & Pick<TableCellProps, 'align'>);

export const DETAIL_COLUMNS: LegendDetailColumn[] = [
  { key: 'code', label: 'Code', width: 50 },
  { align: 'right', key: 'timeRef', label: 'Time Ref', width: 100 },
  { align: 'right', key: 'periodType', label: 'Period Type', width: 120 },
  { align: 'right', key: 'period', label: 'Period', width: 80 },
  { key: 'alias', label: 'Alias', width: 110 },
  { key: 'name', label: 'Title' },
  { align: 'right', key: 'currency', label: 'Currency', width: 80 },
  { align: 'right', key: 'units', label: 'Units', width: 80 }
];

export const TABLE_CELLS: LegendTableColumn[] = [
  ...DETAIL_COLUMNS,
  {
    align: 'right',
    key: 'info',
    label: 'Info',
    width: 60
  }
];

export const LAST_TABLE_CELL_INDEX = TABLE_CELLS.length - 1;

export const getCellValue = (item: FullScreenLegendSeries, key: LegendDetailKey): string =>
  item[key] ?? '-';

export const getLegendSymbol = (item: FullScreenLegendSeries): SymbolKey | undefined => {
  if (!item.code) return undefined;

  return {
    Code: item.code,
    Period: item.period ?? '',
    PeriodType: item.periodType ?? '',
    TimeRef: item.timeRef ?? ''
  };
};

export const getSelectorLabel = (name: string, selected: boolean): string =>
  selected ? `Remove ${name} from selector` : `Add ${name} to selector`;
